import { ButtonList, Card } from "@postenbring/hedwig-react";

export const ButtonWrapper = ({ multiButtons, children, ...props }) =>
    multiButtons ? (
        <Card.BodyActionRow asChild {...props}>
            <ButtonList variant="stretched">{children}</ButtonList>
        </Card.BodyActionRow>
    ) : (
        <Card.BodyActionRow {...props}>{children}</Card.BodyActionRow>
    );
